// extracted by mini-css-extract-plugin
module.exports = {"name":"listItem_name_2i5QUsr","sessions":"listItem_sessions_tyqlmnF","users":"listItem_users_Y6PMg3l","occurrence":"listItem_occurrence_1zZ6mSl"};